'use client';

import { Button } from '@/components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.error('[Next.js Error Page]:', error);
    }
  }, [error]);

  return (
    <div className="min-h-screen bg-ds-surface-white flex items-center justify-center p-4">
      <Card className="w-full max-w-md mx-auto">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-ds-danger-subtlest/20">
            <AlertTriangle className="h-6 w-6 text-ds-danger-default" />
          </div>
          <CardTitle className="text-xl font-semibold text-ds-text-darker">
            Something went wrong
          </CardTitle>
          <CardDescription className="text-ds-text-default">
            We encountered an unexpected error. Please try again or contact
            support if the problem persists.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button onClick={() => reset()} className="w-full">
            <RefreshCw className="mr-2 h-4 w-4" />
            Try again
          </Button>
          {process.env.NODE_ENV === 'development' && (
            <details className="mt-4 p-3 bg-ds-gray-subtlest rounded-md">
              <summary className="cursor-pointer text-sm font-medium text-ds-text-default">
                Error Details
              </summary>
              <pre className="mt-2 text-xs text-ds-text-default overflow-auto">
                {error.message}
              </pre>
            </details>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
